import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { APP_STATUS_LABEL } from '../../Consts/app-status.const';
import { SYSTEM_ROLE_LABEL, SystemRole } from '../../Enums/system-role.enum';
import {
  TenantUserDetailResponse,
  TenantUserOrganizationResponse,
  TenantUserRoleResponse,
} from '../../Interfaces/api/backoffice/user.interface';

export class TenantUser {
  id = '';
  name: string | null = null;
  first_name: string | null = null;
  last_name: string | null = null;
  email: string | null = null;
  app_status: string | null = null;
  job_title: string | null = null;
  role_id: string | null = null;
  system_role: string | null = null;
  licence_state: string | null = null;
  is_root = false;
  organization: TenantUserOrganizationResponse | null = null;
  created_at: string | null = null;
  azure_user_id: string | null = null;
  userPrincipalName: string | null = null;
  displayName: string | null = null;
  employeeId: string | null = null;
  officeLocation: string | null = null;
  mobilePhone: string | null = null;
  preferred_lang: string | null = null;
  preferred_theme: string | null = null;
  role: TenantUserRoleResponse | null = null;
  updated_at: string | null = null;
  deleted_at: string | null = null;

  constructor(data: Partial<TenantUserDetailResponse> = {}) {
    Object.assign(this, data);
  }

  get fullName(): string {
    const composed = [this.first_name, this.last_name].filter(Boolean).join(' ').trim();

    return this.name || composed || this.displayName || this.email || this.id;
  }

  get initialsSeed(): string {
    return this.fullName;
  }

  get isOperator(): boolean {
    return this.system_role !== null;
  }

  get operatorRoleLabelKey(): string {
    const known = Object.values(SystemRole) as string[];

    return this.system_role !== null && known.includes(this.system_role)
      ? SYSTEM_ROLE_LABEL[this.system_role as SystemRole]
      : VALUE_UNRESOLVED;
  }

  get appStatusLabelKey(): string {
    if (this.app_status === null) {
      return VALUE_UNRESOLVED;
    }

    return APP_STATUS_LABEL[this.app_status] || this.app_status;
  }

  get ownsCoreSeat(): boolean {
    return this.role_id !== null;
  }

  get rootEligible(): boolean {
    return this.ownsCoreSeat && !this.is_root;
  }

  get roleName(): string {
    return this.role?.name ?? VALUE_UNRESOLVED;
  }

  get organizationName(): string {
    return this.organization?.name || this.organization?.domain || VALUE_UNRESOLVED;
  }

  get isDeleted(): boolean {
    return this.deleted_at !== null;
  }
}
